module.exports = {
	title: 'Nilrednav',
	description: 'Drawings created by Todd Vanderlin for you and your friends.',
	url: 'http://www.nilrednav.com/',
	keywords: 'drawing, illustration, art, line drawing',
	image: 'https://www.nilrednav.com/static/nilrednav.png'
}